

export const MATERIAL_ICONS_LIST = [
  {
    name: "search",
  },
  {
    name: "home",
  },
  {
    name: "menu",
  },
  {
    name: "close",
  },
  {
    name: "settings",
  },
  {
    name: "done",
  },
  {
    name: "check_circle",
  },
  {
    name: "favorite",
  },
  {
    name: "add",
  },
  {
    name: "delete",
  },
  {
    name: "arrow_back",
  },
  {
    name: "star",
  },
  {
    name: "logout",
  },
  {
    name: "add_circle",
  },
  {
    name: "cancel",
  },
  {
    name: "arrow_drop_down",
  },
  {
    name: "more_vert",
  },
  {
    name: "check",
  },
  {
    name: "check_box",
  },
  {
    name: "toggle_on",
  },
  {
    name: "open_in_new",
  },
  {
    name: "refresh",
  },
  {
    name: "login",
  },
  {
    name: "radio_button_unchecked",
  },
  {
    name: "more_horiz",
  },
  {
    name: "apps",
  },
  {
    name: "radio_button_checked",
  },
  {
    name: "download",
  },
  {
    name: "remove",
  },
  {
    name: "toggle_off",
  },
  {
    name: "bolt",
  },
  {
    name: "arrow_upward",
  },
  {
    name: "filter_list",
  },
  {
    name: "delete_forever",
  },
  {
    name: "autorenew",
  },
  {
    name: "key",
  },
  {
    name: "sort",
  },
  {
    name: "sync",
  },
  {
    name: "add_box",
  },
  {
    name: "block",
  },
  {
    name: "restart_alt",
  },
  {
    name: "menu_open",
  },
  {
    name: "shopping_cart_checkout",
  },
  {
    name: "expand_circle_down",
  },
  {
    name: "backspace",
  },
  {
    name: "undo",
  },
  {
    name: "done_all",
  },
  {
    name: "do_not_disturb_on",
  },
  {
    name: "open_in_full",
  },
  {
    name: "double_arrow",
  },
  {
    name: "sync_alt",
  },
  {
    name: "zoom_in",
  },
  {
    name: "done_outline",
  },
  {
    name: "drag_indicator",
  },
  {
    name: "fullscreen",
  },
  {
    name: "star_half",
  },
  {
    name: "settings_accessibility",
  },
  {
    name: "reply",
  },
  {
    name: "exit_to_app",
  },
  {
    name: "unfold_more",
  },
  {
    name: "library_add",
  },
  {
    name: "cached",
  },
  {
    name: "select_check_box",
  },
  {
    name: "terminal",
  },
  {
    name: "change_circle",
  },
  {
    name: "disabled_by_default",
  },
  {
    name: "swap_horiz",
  },
  {
    name: "swap_vert",
  },
  {
    name: "app_registration",
  },
  {
    name: "download_for_offline",
  },
  {
    name: "close_fullscreen",
  },
  {
    name: "file_open",
  },
  {
    name: "minimize",
  },
  {
    name: "open_with",
  },
  {
    name: "dataset",
  },
  {
    name: "add_task",
  },
  {
    name: "start",
  },
  {
    name: "keyboard_voice",
  },
  {
    name: "create_new_folder",
  },
  {
    name: "forward",
  },
  {
    name: "settings_applications",
  },
  {
    name: "compare_arrows",
  },
  {
    name: "redo",
  },
  {
    name: "zoom_out",
  },
  {
    name: "publish",
  },
  {
    name: "html",
  },
  {
    name: "token",
  },
  {
    name: "switch_access_shortcut",
  },
  {
    name: "fullscreen_exit",
  },
  {
    name: "sort_by_alpha",
  },
  {
    name: "delete_sweep",
  },
  {
    name: "indeterminate_check_box",
  },
  {
    name: "view_timeline",
  },
  {
    name: "settings_backup_restore",
  },
  {
    name: "arrow_drop_down_circle",
  },
  {
    name: "assistant_navigation",
  },
  {
    name: "sync_problem",
  },
  {
    name: "clear_all",
  },
  {
    name: "density_medium",
  },
  {
    name: "heart_plus",
  },
  {
    name: "filter_alt_off",
  },
  {
    name: "expand",
  },
  {
    name: "subdirectory_arrow_right",
  },
  {
    name: "download_done",
  },
  {
    name: "arrow_outward",
  },
  {
    name: "123",
  },
  {
    name: "swipe_left",
  },
  {
    name: "auto_mode",
  },
  {
    name: "saved_search",
  },
  {
    name: "place_item",
  },
  {
    name: "system_update_alt",
  },
  {
    name: "javascript",
  },
  {
    name: "search_off",
  },
  {
    name: "output",
  },
  {
    name: "select_all",
  },
  {
    name: "fit_screen",
  },
  {
    name: "swipe_up",
  },
  {
    name: "dynamic_form",
  },
  {
    name: "hide_source",
  },
  {
    name: "swipe_right",
  },
  {
    name: "switch_access_shortcut_add",
  },
  {
    name: "browse_gallery",
  },
  {
    name: "css",
  },
  {
    name: "density_small",
  },
  {
    name: "assistant_direction",
  },
  {
    name: "check_small",
  },
  {
    name: "youtube_searched_for",
  },
  {
    name: "move_up",
  },
  {
    name: "swap_horizontal_circle",
  },
  {
    name: "data_thresholding",
  },
  {
    name: "install_mobile",
  },
  {
    name: "move_down",
  },
  {
    name: "dataset_linked",
  },
  {
    name: "keyboard_command_key",
  },
  {
    name: "view_kanban",
  },
  {
    name: "swipe_down",
  },
  {
    name: "key_off",
  },
  {
    name: "transcribe",
  },
  {
    name: "send_time_extension",
  },
  {
    name: "swipe_down_alt",
  },
  {
    name: "swipe_left_alt",
  },
  {
    name: "swipe_right_alt",
  },
  {
    name: "swipe_up_alt",
  },
  {
    name: "keyboard_option_key",
  },
  {
    name: "cycle",
  },
  {
    name: "rebase",
  },
  {
    name: "rebase_edit",
  },
  {
    name: "empty_dashboard",
  },
  {
    name: "magic_exchange",
  },
  {
    name: "acute",
  },
  {
    name: "point_scan",
  },
  {
    name: "step_into",
  },
  {
    name: "cheer",
  },
  {
    name: "emoticon",
  },
  {
    name: "explosion",
  },
  {
    name: "water_bottle",
  },
  {
    name: "weather_hail",
  },
  {
    name: "syringe",
  },
  {
    name: "pill",
  },
  {
    name: "genetics",
  },
  {
    name: "allergy",
  },
  {
    name: "medical_mask",
  },
  {
    name: "body_fat",
  },
  {
    name: "barefoot",
  },
  {
    name: "infrared",
  },
  {
    name: "wrist",
  },
  {
    name: "metabolism",
  },
  {
    name: "conditions",
  },
  {
    name: "taunt",
  },
  {
    name: "altitude",
  },
  {
    name: "tibia",
  },
  {
    name: "footprint",
  },
  {
    name: "eyeglasses",
  },
  {
    name: "man_3",
  },
  {
    name: "woman_2",
  },
  {
    name: "rheumatology",
  },
  {
    name: "tornado",
  },
  {
    name: "landslide",
  },
  {
    name: "foggy",
  },
  {
    name: "severe_cold",
  },
  {
    name: "tsunami",
  },
  {
    name: "vape_free",
  },
  {
    name: "sign_language",
  },
  {
    name: "emoji_symbols",
  },
  {
    name: "clear_night",
  },
  {
    name: "emoji_food_beverage",
  },
  {
    name: "hive",
  },
  {
    name: "thunderstorm",
  },
  {
    name: "communication",
  },
  {
    name: "rocket",
  },
  {
    name: "pets",
  },
  {
    name: "public",
  },
  {
    name: "quiz",
  },
  {
    name: "mood",
  },
  {
    name: "gavel",
  },
  {
    name: "eco",
  },
  {
    name: "diamond",
  },
  {
    name: "forest",
  },
  {
    name: "rainy",
  },
  {
    name: "skull",
  },
];
